var _style, _defs, _defs2, _defs3, _path, _defs4, _defs5, _defs6, _path2, _defs7, _defs8, _defs9, _path3, _defs0, _defs1, _defs10, _path4, _defs11, _defs12, _defs13, _path5, _defs14, _defs15, _defs16, _path6, _defs17, _defs18, _defs19, _path7, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _path8, _defs27, _defs28, _defs29, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeometricNeuronWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 42.7",
    style: {
      enableBackground: "new 0 0 40 42.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000144306795729846971480000001120052732386272424_);}\r\n\t.st1{clip-path:url(#SVGID_00000039849182430860774270000005570465970439151025_);}\r\n\t.st2{clip-path:url(#SVGID_00000150089743883575865230000004395546207138713757_);}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{clip-path:url(#SVGID_00000023263008226026709420000003713734905464637594_);}\r\n\t.st5{clip-path:url(#SVGID_00000119108883303808449350000003185420860779322009_);}\r\n\t.st6{clip-path:url(#SVGID_00000148642447040010700310000016287551859684373688_);}\r\n\t.st7{clip-path:url(#SVGID_00000103258744987892404810000002967072961482512288_);}\r\n\t.st8{clip-path:url(#SVGID_00000091706965881538973530000007248038098581915581_);}\r\n\t.st9{clip-path:url(#SVGID_00000137105993429830478430000014861729547000887473_);}\r\n\t.st10{clip-path:url(#SVGID_00000097497044875495013770000009170774506808524680_);}\r\n\t.st11{clip-path:url(#SVGID_00000111193371188227778040000002723961645548371084_);}\r\n\t.st12{clip-path:url(#SVGID_00000054955346587510006360000006345609288759705277_);}\r\n\t.st13{clip-path:url(#SVGID_00000177455498191491619530000012411867806478258596_);}\r\n\t.st14{clip-path:url(#SVGID_00000075857257660566632250000016193125426533404831_);}\r\n\t.st15{clip-path:url(#SVGID_00000101814224081851906170000013628454914489481898_);}\r\n\t.st16{clip-path:url(#SVGID_00000052079541258648499340000014633814800027292849_);}\r\n\t.st17{clip-path:url(#SVGID_00000137841016461878269340000005266838543187837317_);}\r\n\t.st18{clip-path:url(#SVGID_00000098900988709682915690000016509213647928503955_);}\r\n\t.st19{clip-path:url(#SVGID_00000061472145379999251480000016520815654661977733_);}\r\n\t.st20{clip-path:url(#SVGID_00000147924369292429989300000011937265470058675622_);}\r\n\t.st21{clip-path:url(#SVGID_00000018224029435884713160000014156389711089395368_);}\r\n\t.st22{clip-path:url(#SVGID_00000122702484530374311240000010268796607194375825_);}\r\n\t.st23{clip-path:url(#SVGID_00000102546799458641588050000015743210596473872513_);}\r\n\t.st24{clip-path:url(#SVGID_00000072244000754327857440000010909525458868070307_);}\r\n\t.st25{clip-path:url(#SVGID_00000178903499042605868470000004751225823289981586_);}\r\n\t.st26{clip-path:url(#SVGID_00000054945783085955540860000017547753389926337204_);}\r\n\t.st27{clip-path:url(#SVGID_00000171687124967653833690000003016689866664174502_);}\r\n\t.st28{clip-path:url(#SVGID_00000008855439246053295740000005228713658120217007_);}\r\n\t.st29{clip-path:url(#SVGID_00000115479845093347949140000000931652616667126710_);}\r\n\t.st30{clip-path:url(#SVGID_00000088838494737720252520000016037248663772656800_);}\r\n\t.st31{clip-path:url(#SVGID_00000129192063749010261030000005688128757646293936_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 17.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043448716798462868180000012631269630909843902_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000043448716798462868180000012631269630909843902_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000092424472117500449880000001785135719301810089_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028323829150581674760000011394774959963971742_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092424472117500449880000001785135719301810089_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000028323829150581674760000011394774959963971742_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000017504187574478635760000011665769071445462964_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057143949881967393730000006076077152276215204_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017504187574478635760000011665769071445462964_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057143949881967393730000006076077152276215204_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.5,14.5c-2.3,1.3-4.9,2-7.4,2c-2.9,0-5.7-0.9-8-2.6c-0.5-0.3-0.6-1-0.2-1.5c0.3-0.5,1-0.6,1.5-0.2 c1.9,1.4,4.3,2.2,6.7,2.2c3.6,0,7.4-1.7,9.8-4.4c1.5-1.7,3.2-4.5,2.7-8.4C21.5,1,22,0.5,22.5,0.4c0.6-0.1,1.1,0.4,1.2,0.9 c0.4,3.7-0.7,7.2-3.3,10C19.4,12.6,18,13.7,16.5,14.5z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085946623171843566590000005259050645535463352_",
    x: 16,
    y: 25.3,
    width: 24,
    height: 17.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165952461069717403730000018050095947318289585_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085946623171843566590000005259050645535463352_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165952461069717403730000018050095947318289585_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034797156601842687530000007301562640728897190_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162327570475998396280000013274166750359593362_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034797156601842687530000007301562640728897190_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000162327570475998396280000013274166750359593362_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000114782619520389380780000016599464595502729369_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094589694699073825370000017665397471860170920_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000114782619520389380780000016599464595502729369_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000094589694699073825370000017665397471860170920_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.7,30.2c-0.4,0.2-0.8,0.2-1.2-0.1c-1.9-1.4-4.3-2.2-6.7-2.2c-3.6,0-7.4,1.7-9.8,4.4 c-1.5,1.7-3.2,4.5-2.7,8.4c0.1,0.6-0.4,1.1-0.9,1.2c-0.6,0.1-1.1-0.4-1.2-0.9c-0.4-3.7,0.7-7.2,3.3-10 c2.8-3.2,7.2-5.1,11.4-5.2c2.9,0,5.7,0.9,8,2.6c0.5,0.3,0.6,1,0.2,1.5C38.9,30.1,38.8,30.2,38.7,30.2z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000006670681248805446410000004069242075962061729_",
    y: 25.3,
    width: 24,
    height: 17.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003816929540433910730000018221303052620541095_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006670681248805446410000004069242075962061729_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003816929540433910730000018221303052620541095_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005969541073200155240000014154262814827268790_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176722790700601784440000011200506482078915228_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005969541073200155240000014154262814827268790_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176722790700601784440000011200506482078915228_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000067925216568694960990000006145341843574031779_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094601044842655640040000010761934207492495761_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067925216568694960990000006145341843574031779_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000094601044842655640040000010761934207492495761_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.5,42.2c-0.2,0.1-0.4,0.2-0.6,0.1c-0.6-0.1-1-0.6-0.9-1.2c0.3-2.4-0.2-4.8-1.5-6.9 c-1.8-3.1-5.2-5.5-8.8-6.3c-2.2-0.5-5.4-0.5-8.6,1.8C1.6,30,1,29.9,0.6,29.5C0.2,29,0.3,28.4,0.8,28 c3-2.2,6.6-2.9,10.3-2.2c4.1,0.9,8,3.7,10.2,7.3c1.5,2.5,2.1,5.4,1.7,8.2C23,41.7,22.8,42,22.5,42.2z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070109321383074306300000003851854905042749109_",
    x: 16,
    width: 24,
    height: 17.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090990232584711718740000000568967484381355455_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070109321383074306300000003851854905042749109_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090990232584711718740000000568967484381355455_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132083970981079727790000012347890161405709490_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006669167186281753940000013106506625837869193_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132083970981079727790000012347890161405709490_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006669167186281753940000013106506625837869193_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119099689542150037240000014485674151257017762_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098182343740821749730000012807342799489836189_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119099689542150037240000014485674151257017762_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098182343740821749730000012807342799489836189_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.6,15.7c-2.7,1.5-5.7,1.9-8.9,1.3c-4.2-0.9-8-3.7-10.2-7.3c-1.5-2.5-2.1-5.4-1.7-8.2 c0.1-0.6,0.6-1,1.2-0.9s1,0.6,0.9,1.2c-0.3,2.4,0.2,4.8,1.5,6.9c1.8,3.1,5.2,5.5,8.8,6.3c2.2,0.5,5.4,0.5,8.6-1.8 c0.5-0.3,1.1-0.2,1.5,0.2c0.3,0.5,0.2,1.1-0.2,1.5C38.5,15.1,38.1,15.4,37.6,15.7z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000151526282717556370700000012058606117661969855_",
    x: 26.7,
    y: 8,
    width: 12,
    height: 28
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003083296250076302900000017469231970214304949_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151526282717556370700000012058606117661969855_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003083296250076302900000017469231970214304949_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000121265835432223021020000001105042880373688243_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002349879387948105870000015738118731236103853_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121265835432223021020000001105042880373688243_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000002349879387948105870000015738118731236103853_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000085223452683611513590000018261413073104778670_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065034723227013123500000018184339848887942276_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085223452683611513590000018261413073104778670_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000065034723227013123500000018184339848887942276_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.4,34.5c-0.3,0.2-0.6,0.2-0.9,0c-3.4-1.5-5.8-4.2-7-7.8c-1.3-4-0.9-8.8,1.2-12.4 c1.4-2.5,3.7-4.5,6.3-5.6c0.5-0.2,1.2,0,1.4,0.6c0.2,0.5,0,1.2-0.6,1.4c-2.2,0.9-4.1,2.6-5.3,4.7 c-1.8,3.1-2.2,7.3-1.1,10.7c0.7,2.1,2.3,5,5.9,6.6c0.5,0.2,0.8,0.9,0.5,1.4C36.7,34.3,36.6,34.4,36.4,34.5z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000072972185469734497170000014836204176474441350_",
    x: 2.7,
    y: 8,
    width: 10.7,
    height: 26.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072974202032423370720000003662233088373700513_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072972185469734497170000014836204176474441350_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072974202032423370720000003662233088373700513_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036956687140989973250000012809146853091657642_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056416615389666006180000015321725847667966097_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036956687140989973250000012809146853091657642_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056416615389666006180000015321725847667966097_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116195946500042839310000002390055564959233170_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101069713290422660950000012529229752044851134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116195946500042839310000002390055564959233170_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101069713290422660950000012529229752044851134_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.6,33.5c-0.4,0.2-0.8,0.4-1.2,0.6c-0.5,0.2-1.2,0-1.4-0.6c-0.2-0.5,0-1.2,0.6-1.4 c2.2-0.9,4-2.6,5.2-4.7c1.8-3.1,2.2-7.2,1.1-10.7c-0.7-2.1-2.3-5-5.9-6.6C3.5,9.9,3.3,9.2,3.5,8.7s0.9-0.8,1.4-0.5 c3.4,1.5,5.8,4.2,7,7.8c1.3,4,0.8,8.8-1.2,12.4C9.5,30.5,7.7,32.3,5.6,33.5z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173883453295762014280000004816809292160239513_",
    x: 14.7,
    y: 16,
    width: 10.7,
    height: 10.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036236329788777690330000014888401575051010445_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173883453295762014280000004816809292160239513_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036236329788777690330000014888401575051010445_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000094594189211943969710000011927680480733308582_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014593447721874803350000016848496535709128614_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094594189211943969710000011927680480733308582_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014593447721874803350000016848496535709128614_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163057877753344174030000000920561196911271084_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000058590509849586071810000003440257584397361290_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163057877753344174030000000920561196911271084_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000058590509849586071810000003440257584397361290_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.6,18.8c1.4,2.5,0.5,5.7-2,7.1s-5.7,0.5-7.1-2c-1.4-2.5-0.5-5.7,2-7.1S23.2,16.3,24.6,18.8z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000092414679643944538910000001668904339195122091_",
    x: 16,
    y: 13.3,
    width: 12,
    height: 13.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032638848258924311970000004922779077737952697_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000092414679643944538910000001668904339195122091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000032638848258924311970000004922779077737952697_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000048484028700756050700000006723303023318097328_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137100698889500344380000014559382709735447461_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048484028700756050700000006723303023318097328_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137100698889500344380000014559382709735447461_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062895310021436059660000014635787924789551753_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111179546085817549430000012939756370734906282_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062895310021436059660000014635787924789551753_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111179546085817549430000012939756370734906282_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 717, 399)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152967801629686376530000002317997101243506094_",
    x: -701,
    y: -385.7,
    width: 12,
    height: 13.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015318560690267832770000002370010141985319851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152967801629686376530000002317997101243506094_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000015318560690267832770000002370010141985319851_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000094597648876729018300000003942222399399509670_",
    x: -700.2,
    y: -383,
    width: 8.5,
    height: 10.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000143593624876259121000000004876338869366290326_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094597648876729018300000003942222399399509670_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000143593624876259121000000004876338869366290326_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000158008624875148667820000007030311324374009742_",
    x: -718,
    y: -397.2,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 95.7033 -385.267)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004516398272636881860000010658413726381266356_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000158008624875148667820000007030311324374009742_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000004516398272636881860000010658413726381266356_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181803947573941396760000016067450063958179740_",
    x: -718,
    y: -397.2,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 95.7033 -385.267)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023985347498153776720000005533882714627094189_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181803947573941396760000016067450063958179740_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023985347498153776720000005533882714627094189_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-692.4-380.2c1.4,2.5,0.5,5.7-2,7.1c-0.2,0.1-0.4,0.2-0.6,0.3c2.1-1.5,2.8-4.4,1.5-6.8 c-1.3-2.3-4.1-3.3-6.5-2.3c0.2-0.1,0.3-0.2,0.5-0.3C-697-383.6-693.8-382.7-692.4-380.2z"
  }))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000064348645735311915600000008024004635106571685_",
    x: 17.3,
    y: 18.7,
    width: 5.3,
    height: 5.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172425857396102474250000017503564676181677988_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064348645735311915600000008024004635106571685_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000172425857396102474250000017503564676181677988_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000154384532108894116990000013634154985799690386_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077299285277638472920000011356809607549115559_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154384532108894116990000013634154985799690386_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000077299285277638472920000011356809607549115559_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000145047601373374621460000008831088188103376788_",
    x: -1,
    y: 1.8,
    transform: "matrix(0.8746 -0.4848 0.4848 0.8746 -7.8165 12.3543)",
    width: 42,
    height: 39
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080166852994779543100000016894616731942540948_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145047601373374621460000008831088188103376788_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080166852994779543100000016894616731942540948_)"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.3,20.1c0.7,1.2,0.2,2.8-1,3.5s-2.8,0.2-3.5-1s-0.2-2.8,1-3.5S21.6,18.9,22.3,20.1z"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometricNeuronWhite);
export default __webpack_public_path__ + "static/media/geometric-neuron-white.4e308c8135994698d9795e6d6a31f6a0.svg";
export { ForwardRef as ReactComponent };